import infoSys from "assets/img/train/summer-institute.png";

export const courseSupport = {
  paragraph: "We are grateful for the support and partnership of",
  logo: {
    src: infoSys,
    alt: "Info System",
  },
};
